/**
 * `getInsuranceSegmentKeyPrefix` is used to acquire
 * the prefix of a given segment.
 *
 * **Example:**
 * ```js
 * let segmentPrefix = getInsuranceSegmentKeyPrefix('01.0_AH')
 * // segmentPrefix equals 'AH'
 *
 * segmentPrefix = getInsuranceSegmentKeyPrefix('some~random/string')
 * // segmentPrefix equals null
 *
 * segmentPrefix = getInsuranceSegmentKeyPrefix(undefined)
 * // segmentPrefix equals null
 *
 * segmentPrefix = getInsuranceSegmentKeyPrefix('')
 * // segmentPrefix equals null
 *
 *
 * ```
 */
export function getInsuranceSegmentKeyPrefix(segment) {
    if (typeof segment === 'string' && segmentRegex.test(segment)) {
        return segment.split('_')?.pop() ?? null;
    }
    return null;
}
/**
 * `segmentRegex` is used to determine whether a string
 * is an insuranceSegment or not.
 *
 * Below is an example using the segment key `01.0_AH`:
 *
 * `[01].0_AH`
 *
 * The first part of the regex `[0-9]{2}` ensures the first
 * two characters are numbers from zero to nine.
 *
 * `01[.0_]AH`
 *
 * The second part of the regex ensures the string has a period,
 * followed by a number from zero to two, and finishes with an
 * underscore.
 *
 * `01.0_[AH]`
 *
 * The final part of the regex checks the end of the string for
 * one to two uppercase letters.
 */
export const segmentRegex = /[0-9]{2}(?:.[0-2]_)(?:[A-Z]{1,2})/;
